(() => {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const commerceButtonSelector = [
    'button[name="add"]',
    '.product-form button[type="submit"]',
    '[data-fbt-add]',
    '.hayyen-qty-offer__actions button',
    '.hayyen-cart-cross-sell button',
    '.hayyen-minicart-cross button'
  ].join(',');

  const replay = (element, className, duration = 520) => {
    if (!element) return;
    element.classList.remove(className);
    void element.offsetWidth;
    element.classList.add(className);
    window.setTimeout(() => element.classList.remove(className), duration);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(commerceButtonSelector);
    if (!button || button.disabled) return;
    replay(button, 'hayyen-atc-click', 500);
  }, { passive: true });

  document.addEventListener('submit', (event) => {
    const button = event.submitter;
    if (!button || !button.matches(commerceButtonSelector) || button.disabled) return;
    replay(button, 'hayyen-atc-click', 500);
  });

  const syncFbtSelection = (input) => {
    const item = input.closest('.hayyen-fbt__item--optional');
    if (!item) return;
    item.classList.toggle('is-selected', input.checked);
  };

  document.querySelectorAll('.hayyen-fbt__item--optional .hayyen-fbt__input').forEach(syncFbtSelection);

  document.addEventListener('change', (event) => {
    if (event.target.matches('.hayyen-fbt__item--optional .hayyen-fbt__input')) {
      syncFbtSelection(event.target);
    }
  });

  const cartLink = document.querySelector('.js-minicart-link');
  if (cartLink && 'MutationObserver' in window) {
    let previous = cartLink.textContent.trim();
    const observer = new MutationObserver(() => {
      const current = cartLink.textContent.trim();
      if (current !== previous) {
        previous = current;
        replay(cartLink, 'hayyen-cart-pop', 560);
      }
    });
    observer.observe(cartLink, { subtree: true, childList: true, characterData: true });
  }
})();
